import React, { type ReactElement } from "react";

import {
  ChatTeardropText,
  ChatsTeardrop,
  Couch,
  Files,
  FolderOpen,
  Handshake,
  MathOperations,
  PhoneDisconnect,
  Scales,
  Scroll,
  Webcam,
} from "@phosphor-icons/react/dist/ssr";

export const servicesIcons: Record<string, ReactElement<any>> = {
  phone: React.createElement(PhoneDisconnect, { "aria-hidden": "true", weight: "duotone" }),
  video: React.createElement(Webcam, { "aria-hidden": "true", weight: "duotone" }),
  chat: React.createElement(ChatsTeardrop, { "aria-hidden": "true", weight: "duotone" }),
  in_person: React.createElement(Couch, { "aria-hidden": "true", weight: "duotone" }),
  contract: React.createElement(Files, { "aria-hidden": "true", weight: "duotone" }),
  petition: React.createElement(Scroll, { "aria-hidden": "true", weight: "duotone" }),
  complaint: React.createElement(Scroll, { "aria-hidden": "true", weight: "duotone" }),
  bill: React.createElement(Scroll, { "aria-hidden": "true", weight: "duotone" }),
  declaration: React.createElement(Scroll, { "aria-hidden": "true", weight: "duotone" }),
  calculation: React.createElement(MathOperations, { "aria-hidden": "true", weight: "duotone" }),
  case_studying: React.createElement(FolderOpen, { "aria-hidden": "true", weight: "duotone" }),
  judgement: React.createElement(Handshake, { "aria-hidden": "true", weight: "duotone" }),
  advocacy: React.createElement(Scales, { "aria-hidden": "true", weight: "duotone" }),
  questions_answered: React.createElement(ChatTeardropText, {
    "aria-hidden": "true",
    weight: "duotone",
  }),
};
